/** @jsx jsx */

import { jsx } from '@emotion/core';

import DeveloperFormFields from 'app/developer-v3/components/DeveloperFormFields';
import getFormFields from 'app/developer-v3/pages/actions/ActionApi/formFields';

import type { ActionType } from 'app/developer-v3/types';

type Props = {
  meta?: {};
  isDisabled: boolean;
  onChange: (value: {}, name: string) => void;
  type: ActionType;
  value: {};
};

const Config = (props: Props) => (
  <DeveloperFormFields
    fields={getFormFields(props.type)}
    meta={props.meta}
    onFormChange={props.onChange}
    readOnly={props.isDisabled}
    values={props.value}
  />
);

export default Config;
